export default function (state) {
  const defaultKeys = [
    "address",
    "postcode",
    "switchType",
    "emailAddress",
    "accountManagementOnline",
    "referrerBranchCode",
    "billConsumptionIsEstimated",
    "isHappyToBeAutoSwitched",
    "customerId",
    "switchOwnerReference",
    "newTariffPaymentMethod"
  ];

  const switchingTypes = {
    dualDistinctToDualConsolidated: [
      "electricitySupplierId",
      "electricitySupplierName",
      "electricityTariffName",
      "gasSupplierId",
      "gasSupplierName",
      "gasTariffName",
      "electricityConsumptionExceedsGasConsumption",
      "electricityTariffId",
      "electricityTariffValidToDate",
      "electricityCurrentPayMethod",
      "electricityUtilityPeriod",
      "economy7Percentage",
      "electricityCurrentCostEstimated",
      "electricityCurrentUsageEstimated",
      "gasTariffId",
      "gasTariffValidToDate",
      "gasCurrentPayMethod",
      "gasUtilityPeriod",
      "gasCurrentCostEstimated",
      "gasCurrentUsageEstimated",
      ...defaultKeys
    ],
    dualConsolidatedToDualConsolidated: [
      "supplierId",
      "supplierName",
      "tariffName",
      "electricityConsumptionExceedsGasConsumption",
      "tariffId",
      "tariffValidToDate",
      "currentPayMethod",
      "utilityPeriod",
      "economy7Percentage",
      "electricityCurrentCostEstimated",
      "electricityCurrentUsageEstimated",
      "gasCurrentCostEstimated",
      "gasCurrentUsageEstimated",
      ...defaultKeys
    ],
    gasToGas: [],// <---- not possible
    electricityToElectricity: [
      "supplierId",
      "supplierName",
      "tariffName",
      "tariffId",
      "tariffValidToDate",
      "currentPayMethod",
      "utilityPeriod",
      "economy7Percentage",
      "currentCostEstimated",
      "currentUsageEstimated",
      ...defaultKeys
    ]
  };

  let model = {};
  const requiredKeys = switchingTypes[state.switchType];

  for (let index = 0; index < requiredKeys.length; index++) {
    const key = requiredKeys[index];
    model[key] = state[key];
  }

  if (state.compareFuel == 'gasElectricity') {
    model.electricityConsumptionExceedsGasConsumption = Number(state.electricityCurrentUsageEstimated) > Number(state.gasCurrentUsageEstimated);
  }

  return model;
}
